import { IConversionApiField } from './form-conversion.model';

export abstract class ConversionApiData {
    public static eventData: IConversionApiField[] = [
        {
            name: 'intent',
            options: {
                identifier: 'get_started_and_contact_us',
                element: 'select',
            },
        },
        {
            name: 'timeline',
            options: {
                identifier: 'project_timeline',
                element: 'select',
            },
        },
        {
            name: 'application_type',
            options: {
                identifier: 'applications_group',
                element: 'select',
            },
        },
    ];

    public static userData: IConversionApiField[] = [
        {
            name: 'sha256_email',
            options: {
                identifier: 'email',
                element: 'input',
                normalizer: 'email',
                hash: true,
            },
        },
        {
            name: 'sha256_phone',
            options: {
                identifier: 'phone',
                element: 'input',
                normalizer: 'phone',
                hash: true,
            },
        },
        {
            name: 'sha256_phone_e164',
            options: {
                identifier: 'phone',
                element: 'input',
                normalizer: 'phone_e164',
                hash: true,
            },
        },
        {
            name: 'sha256_first_name',
            options: {
                identifier: 'first_name',
                element: 'input',
                hash: true,
            },
        },
        {
            name: 'sha256_last_name',
            options: {
                identifier: 'last_name',
                element: 'input',
                hash: true,
            },
        },
        {
            name: 'sha256_postal_code',
            options: {
                identifier: 'zip',
                element: 'input',
                normalizer: 'zip',
                hash: true,
            },
        },
        {
            name: 'email',
            options: {
                identifier: 'email',
                element: 'input',
                normalizer: 'email',
            },
        },
        {
            name: 'first_name',
            options: {
                identifier: 'first_name',
                element: 'input',
            },
        },
        {
            name: 'last_name',
            options: {
                identifier: 'last_name',
                element: 'input',
            },
        },
        {
            name: 'country',
            options: {
                identifier: 'country',
                element: 'input',
            },
        },
        {
            name: 'phone',
            options: {
                identifier: 'phone',
                element: 'input',
                normalizer: 'phone',
            },
        },
        {
            name: 'zip',
            options: {
                identifier: 'zip',
                element: 'input',
                normalizer: 'zip',
            },
        },
        {
            name: 'role',
            options: {
                identifier: 'user_role',
                element: 'select',
            },
        },
        {
            name: 'role_subcategory',
            options: {
                identifier: [
                    'user_role_subcategory_end_user',
                    'user_role_subcategory_other',
                    'user_role_subcategory_partner',
                    'user_role_subcategory_student',
                ],
                element: 'select',
            },
        },
        {
            name: 'industry',
            options: {
                identifier: 'industry',
                element: 'select',
            },
        },
        {
            name: 'country',
            options: {
                identifier: 'country',
                element: 'select',
                normalizer: 'country',
            },
        },
        {
            name: 'sha256_country',
            options: {
                identifier: 'country',
                element: 'select',
                normalizer: 'country',
                hash: true,
            },
        },
        {
            name: 'state',
            options: {
                identifier: [
                    'state_region_au',
                    'state_region_ca',
                    'state_region_cn',
                    'state_region_in',
                    'state_region_jp',
                    'state_region_latam_br',
                    'state_region_latam_mx',
                    'state_region_semea',
                    'state_region_us',
                ],
                element: 'select',
                normalizer: 'state',
            },
        },
        {
            name: 'sha256_state',
            options: {
                identifier: [
                    'state_region_au',
                    'state_region_ca',
                    'state_region_cn',
                    'state_region_in',
                    'state_region_jp',
                    'state_region_latam_br',
                    'state_region_latam_mx',
                    'state_region_semea',
                    'state_region_us',
                ],
                element: 'select',
                normalizer: 'state',
                hash: true,
            },
        },
    ];
}
